import { parseTransferNote } from "@33cn/chain33-transaction-parser";

/**
 * @export 时间戳转换
 * @param {(number | string | Date)} date
 * @param {string} [format='yyyy-MM-dd hh:mm:ss']
 * @returns {(string | number)}
 */
export function formatTime(
    date: number | string | Date,
    format = "yyyy-MM-dd hh:mm:ss"
): string | number {
    if (!date) return "";
    if (typeof date === "number") {
        if (Math.floor(date / 1e9) > 0 && Math.floor(date / 1e9) < 10) {
            date = date * 1000;
        }
        date = new Date(date + 3600000 * 8);
    } else if (typeof date === "string") {
        // timestamp in secounds
        if (/^\d{10}$/.test(date)) {
            date = new Date(Number(date) * 1000 + 3600000 * 8);
        } else {
            // ios 中使用 new Date( yyyy-MM-dd hh:mm:ss:SS ) 时间格式字符串不能精确到 小时以后
            const dateArr = date.split(/[- :]/);
            const now = new Date();
            date = new Date(
                Number(dateArr[0]) || now.getFullYear(),
                dateArr[1] && parseInt(dateArr[1])
                    ? parseInt(dateArr[1]) - 1
                    : now.getMonth() - 1,
                parseInt(dateArr[2]) || 1,
                parseInt(dateArr[3]) || 0,
                parseInt(dateArr[4]) || 0,
                parseInt(dateArr[5]) || 0
            );
        }
    } else {
        /* eslint-disable-next-line */
        console.error("wrong format", date);
        return "";
    }

    if (format === "timestamp") return +date;

    const map = {
        M: date.getUTCMonth() + 1, // 月份
        d: date.getUTCDate(), // 日
        h: date.getUTCHours(), // 小时
        m: date.getUTCMinutes(), // 分
        s: date.getUTCSeconds(), // 秒
        q: Math.floor((date.getUTCMonth() + 3) / 3), // 季度
        S: date.getUTCMilliseconds(), // 毫秒
        W:
            "星期" +
            ["日", "一", "二", "三", "四", "五", "六"][date.getUTCDay()], // 星期
    };
    format = format.replace(/([yMdhmsqSW])+/g, function (all, t) {
        let v = map[t];
        if (v !== undefined) {
            if (all.length > 1) {
                v = "0" + v;
                v = v.substr(v.length - 2);
            }
            return v;
        } else if (t === "y") {
            return ((date as Date).getUTCFullYear() + "").substr(
                4 - all.length
            );
        }
        return all;
    });
    return format;
}

/**
 * @截断hash
 * @export
 * @param {string} str
 * @param {number} [num=16]
 * @returns {string}
 */
export function filterHash(str: string, num = 16): string {
    if (str == "") return "";
    else return String(str).substr(0, num) + "..." + String(str).substr(-4);
}

/**
 * @export 解码转账交易中的note字段
 * @param {*} tx
 * @returns {string}
 */
export function decodeTransferNote(tx: any): string {
    let payload = "";
    // if (tx.execer === 'user.p.xunku.storage') {
    //   return JSON.parse(`${deCode(tx.rawPayload)}`)
    // }
    if (!tx.payload) return tx.rawPayload;
    else {
        payload = tx.payload;
    }
    const keys = ["transfer", "withdraw", "transferToExec"];
    const key = keys.find((item) => payload[item]);
    if (key && payload[key].note) {
        payload[key].note = parseTransferNote(payload[key].note);
    }
    return payload;
}

/**
 * @export 过滤交易组
 * @param {*} trade
 * @returns {string}
 */
export function tradeGroup(trade: any): string {
    if (trade.tx && trade.tx.groupCount > 1) return "数据组";
    else return "普通数据";
}

/**
 * @export 倒数计时器
 * @param {(number | string)} time
 * @returns {string}
 */
export function caculateTime(time: number | string): string {
    const Dt = new Date();
    const local = Dt.getTime();
    time = Number(time);
    let dValue: number = parseInt(String(local / 1000 - time));
    const h = parseInt(String(dValue / 3600));
    dValue -= h * 3600;
    const m = parseInt(String(dValue / 60));
    dValue -= m * 60;
    const s = parseInt(String(dValue));
    if (parseInt(String(local / 1000 - time)) >= 86400)
        return String(formatTime(time));
    else if (parseInt(String(local / 1000 - time)) >= 3600)
        return `${h}小时${m}分${s}秒前`;
    else if (parseInt(String(local / 1000 - time)) >= 60)
        return `${m}分${s}秒前`;
    else return `${s}秒前`;
}

/**
 * @export 数字位数过滤
 * @param {(number | string)} num
 * @returns {(string | undefined)}
 */
export function filterNum(num: number | string): string | undefined {
    if (!num || num === null || num === "") return;
    const n = String(num).split(".");
    const b = parseInt(n[0]).toString();
    const len = b.length;
    let result = "";
    if (len <= 3) {
        result = b;
    } else {
        const r = len % 3;
        result =
            r > 0
                ? b.slice(0, r) +
                  "," +
                  (b.slice(r, len).match(/\d{3}/g) as RegExpExecArray).join(",")
                : (b.slice(r, len).match(/\d{3}/g) as RegExpMatchArray).join(
                      ","
                  );
    }
    if (n[1]) {
        return result + `.${n[1]}`;
    } else {
        return result;
    }
}

/**
 * 判断交易的准确性 return false交易成功  true交易失败
 * @param {交易执行器} Actuators
 * @param {交易type} ty
 */
export function tradeAccuracy(
    Actuators: string,
    ty: number | string,
    tyName: string
): boolean {
    if (
        Actuators.slice(Actuators.length - 4) == "none" ||
        (Actuators.substring(0, 5) == "user." && tyName == "ExecPack")
    ) {
        return false;
    } else {
        if (ty == 1) {
            return true;
        } else {
            return false;
        }
    }
}
